import React, { useState, useRef } from "react";
import * as Utils from "core/common/utils";
import "./PreAuthenticationField.scoped.scss";
import clsx from "clsx";

const PreAuthenticationField = ({ options }) => {
    const inputRef = useRef(null);
    const [shouldShowPassword, setShouldShowPassword] = useState(false);

    const [hiddenPassword, setHiddenPassword] = useState("");
    const refTime = useRef(null);

    const {
        formik,
        fieldName,
        label,
        inputType,
        policyMessage,
        shouldAllowTogglePasswordVisibility,
        isNumber,
        serverError,
        maxLength,
        className,
        baseId,
    } = options;
    const errorMessage = serverError || Utils.getFormikError(fieldName, formik);

    let fieldInputType = inputType || "text";
    if (shouldAllowTogglePasswordVisibility) {
        fieldInputType = inputType;
    } else if (isNumber) {
        fieldInputType = "number";
    }

    // todo: buggy. must be revised. (password type problem)
    const handleHiddenPassword = (e) => {
        let len = e.target.value.length;
        let saved = e.target.value;
        let passwordValue = formik.values[fieldName]
            ? formik.values[fieldName].length < len
                ? formik.values[fieldName] + saved.substring(len - 1)
                : len === 1 && saved !== "•" ? saved : formik.values[fieldName].substring(len, -1)
            : saved;
        clearTimeout(refTime.current);

        e.target.value = passwordValue;
        formik.handleChange(e);
        setHiddenPassword(
            saved.substring(0, len - 1).replace(/./g, "•") +
            saved.substring(len - 1, len)
        );
        refTime.current = setTimeout(() => {
            setHiddenPassword(saved.replace(/./g, "•"));
        }, 1000);
    };

    return (
        <div className="preliminary_form_field_item">
            <div
                className={clsx("preliminary_form_field", errorMessage && "error_code")}
            >
                <div
                    id={baseId ? `${baseId}-input-wrapper` : null}
                    className={clsx(
                        "preliminary_form_field_bg",
                        errorMessage && "error_code"
                    )}
                >
                    {fieldInputType !== "number" ?
                        <input
                            className={clsx("text_field", className)}
                            type={shouldShowPassword ? "text" : fieldInputType}
                            placeholder=""
                            name={fieldName}
                            autoComplete={fieldName === "password" ? "off" : "on"}
                            maxLength={maxLength ? maxLength : null}
                            {...formik.getFieldProps(fieldName)}
                            ref={(el) => {
                                inputRef.current = el;
                            }}
                            pattern={isNumber ? "d*" : null}
                            onChange={formik.handleChange}
                            value={formik.values[fieldName]}
                        />
                        :
                        <input
                            className={clsx("text_field", className)}
                            type="tel"
                            name={fieldName}
                            autoComplete="on"
                            maxLength={maxLength ? maxLength : null}
                            {...formik.getFieldProps(fieldName)}
                            ref={(el) => {
                                inputRef.current = el;
                            }}
                            pattern="[0-9]*"
                            onChange={formik.handleChange}
                            value={formik.values[fieldName]}
                        />
                    }

                    <label className="floating_label">
                        <span>{label}</span>
                    </label>
                    {policyMessage && (
                        <div className="password_required">
                            <small>{policyMessage}</small>
                        </div>
                    )}

                    {shouldAllowTogglePasswordVisibility && (
                        <div className="show_possword_num">
                            <span

                                onClick={(e) => {
                                    e.preventDefault();
                                    setShouldShowPassword(!shouldShowPassword);
                                }}
                            >
                                <small>
                                    <i
                                        className={clsx(
                                            "fa",
                                            shouldShowPassword ? "ion-ios-eye" : "ion-eye-disabled"
                                        )}
                                    />
                                </small>
                            </span>
                        </div>
                    )}
                </div>
                {errorMessage && (
                    <div className="error_info">
                        <span
                            className={clsx("error_info_msg", policyMessage && "has_policy")}
                        >
                            {errorMessage}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PreAuthenticationField;